import CustomTextInput from '../../../common/components/CustomTextInput';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type MusicAlbumEditForm3EditPopupViewTitleInputFieldName =
  'title'|'title_kana'|'title_en';

/**
 * タイトル入力
 */
export default function MusicAlbumEditForm3EditPopupViewTitleInput({
  getValue,
  setValue,
  getErrors,
} : {
  getValue: (name: MusicAlbumEditForm3EditPopupViewTitleInputFieldName) => string,
  setValue: (name: MusicAlbumEditForm3EditPopupViewTitleInputFieldName, value: string) => void,
  getErrors: (name: MusicAlbumEditForm3EditPopupViewTitleInputFieldName) => FieldValidationErrorsType,
}) {
  return (
    <>
      <span className="ttl_parent">
        曲名
      </span>
      <div className="parent_body">
        <dl>
          <dt>
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <label htmlFor="/">曲名</label>
          </dt>
          <dd>
            <CustomTextInput
              placeholder="Frekul Song"
              value={getValue('title')}
              setValue={(value) => setValue('title', value)}
              validationErrors={getErrors('title')}
            />
            <p className="text_info_on">
              楽曲のタイトルにサブタイトルがある場合、楽曲のタイトルとサブタイトルの間に半角スペースを入れ、サブタイトル名を 〜○○○〜 や -○○○- と入力を行ってください。
              <br />
              <br />
              例：Story -春夏秋冬-
              <br />
              例：Story 〜春夏秋冬〜
              <br />
            </p>
          </dd>
        </dl>
        <dl>
          <dt>
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <label htmlFor="/">読み（ひらがな）</label>
          </dt>
          <dd>
            <CustomTextInput
              placeholder="ふりくるそんぐ"
              value={getValue('title_kana')}
              setValue={(value) => setValue('title_kana', value)}
              validationErrors={getErrors('title_kana')}
            />
          </dd>
        </dl>
        <dl>
          <dt>
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <label htmlFor="/">海外向け (英語またはローマ字)</label>
          </dt>
          <dd>
            <CustomTextInput
              placeholder="Frekul Song"
              value={getValue('title_en')}
              setValue={(value) => setValue('title_en', value)}
              validationErrors={getErrors('title_en')}
            />
            <p className="text_info_off">ここに説明文</p>
          </dd>
        </dl>
      </div>
    </>
  );
}
